import React from 'react'
import globals from '../globals'
import LineChart from './LineChart'

class UsageGraphsBroadband extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            currentDatasets: []
        }

        this.colors = {
            peak: '#63D481',
            offpeak: '#004346',
            downloads: '#63D481',
            uploads: '#559ea0',
            total: '#004346'
        }
    }

    componentDidMount () {
        this.populateDatasets()
    }

    componentDidUpdate (prevProps) {
        if (this.props.usageHistorical !== prevProps.usageHistorical) {
            this.populateDatasets()
        }
    }

    populateDatasets () {
        const currentDatasets = []

        this.props.usageHistorical.forEach(item => {
            const color = this.colors[item.type]

            currentDatasets.push({
                label: item.label,
                data: item.data,
                borderColor: color,
                pointBorderColor: color,
                pointHoverBorderColor: color,
                pointHoverBackgroundColor: color,
                backgroundColor: color,
                fill: false,
                lineTension: 0,
                pointRadius: 6,
                pointHoverRadius: 6,
                pointBackgroundColor: '#fff',
                pointBorderWidth: 3,
                pointHoverBorderWidth: 3
            })
        })

        this.setState({ currentDatasets: currentDatasets })
    }

    render () {
        return (
            <div className='usage-graphs-broadband' ref={el => this.container = el}>
                {this.state.currentDatasets.length > 0
                    ? <LineChart
                            labels={this.props.labels}
                            datasets={this.state.currentDatasets}
                            legend
                    >{this.props.children}
                    </LineChart>
                    : ''}
            </div>
        )
    }
}

export default UsageGraphsBroadband



// WEBPACK FOOTER //
// ./resources/js/components/UsageGraphsBroadband.js